import styled from 'styled-components';

export const TagWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TagTextStyled = styled.span`
  font-size: 1.6rem;
  line-height: 2rem;
`;
